import type { IncomingHttpHeaders } from "node:http";

interface ICause<R = unknown> {
    status: number;
    statusText?: string;
    url: string;
    data: R;
    headers: IncomingHttpHeaders;
}

export class FetchError<R = unknown> extends Error {
    cause: ICause<R>;

    constructor(cause: ICause<R>) {
        const message = `Fetch error: ${cause.status} ${cause.statusText}`;
        super(message);
        this.name = "FetchError";
        this.cause = cause;
    }
}
export const isFetchError = <R>(error: unknown): error is FetchError<R> => error instanceof FetchError;

export const isFetchErrorBody = <R>(error: unknown): error is ICause<R> =>
    !!error &&
    typeof error === "object" &&
    "status" in error &&
    typeof error.status === "number" &&
    "statusText" in error &&
    typeof error.statusText === "string" &&
    "url" in error &&
    typeof error.url === "string" &&
    "data" in error;
